import type { ModelProviderOverride } from "../slices/ui";

export interface SessionCreateInput {
  model: string;
  devcontainer?: string;
  modelProvider?: ModelProviderOverride;
}

// Account setting (null) omits the key entirely: the server resolves the authenticated Account's
// LlmAccount, which is also how a second tab's provider change reaches this one. Only an explicit
// OpenRouter or Anthropic choice in THIS tab puts a provider on the wire.
export function sessionCreateFrame(input: SessionCreateInput) {
  const frame: {
    type: "session.create";
    model: string;
    devcontainer?: string;
    modelProvider?: Exclude<ModelProviderOverride, null>;
  } = { type: "session.create", model: input.model };
  if (input.devcontainer) frame.devcontainer = input.devcontainer;
  if (input.modelProvider) frame.modelProvider = input.modelProvider;
  return frame;
}
